import React, {useEffect, useState } from 'react';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { InfoCPUserScreen } from './screen';

export const InfoCPUser = (props:any)=>{

    const {params} = props;
    const {resultError, exceptionError,launchNotification} = useNotifications();
    const [data, setData] = useState(undefined);
    const IdEmpleado = params.idEmpleado;

    useEffect(()=>{
        getInfo()
    },[])

    const getInfo = async() =>{
        const api = new UsuariosAdapter();
        let result:any;
        try {
        result =  await api.ListarCentrosCosteUsuario(IdEmpleado)
        if(result.data && result.data!=="")
        {
            setData(result.data);
        }else{resultError();}
        } catch (e) {
            let exception = ServerErrorMessage(e);
            exceptionError(exception)
        }
    }

    const updateCentrosCoste = async(centrosCoste:any[]) =>{
        const api = new UsuariosAdapter();
        let result:any;
        try {
        result =  await api.ModificarCentrosCosteUsuario(IdEmpleado,centrosCoste)
        if(result.data && result.data!=="" && result.data===true)
        {
            launchNotification({type:"success",title:"Modificación",message:"Se han modificado centros de coste."})
            return result.data;
        }else{resultError();}
        } catch (e) {
            let exception = ServerErrorMessage(e);
            exceptionError(exception)
        }
    }

    return(
        <InfoCPUserScreen data={data} refresh={getInfo} handleUpdate={updateCentrosCoste} user={params.nombre}/>
    )
}